import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {MdcIconModule} from '@shraddhar/mdc-test-web/icon';
import {MdcChip, MdcChipIcon, MdcChipCheckmark} from './chip';
import {MdcChipPrimaryAction, MdcChipText} from './chip-directives';
import {MdcChipSet} from './chip-set';

const CHIP_DECLARATIONS = [
  MdcChip,
  MdcChipCheckmark,
  MdcChipIcon,
  MdcChipPrimaryAction,
  MdcChipSet,
  MdcChipText
];

@NgModule({
  imports: [CommonModule, MdcIconModule],
  exports: CHIP_DECLARATIONS,
  declarations: CHIP_DECLARATIONS
})
export class MdcChipsModule { }
